import request from "../utils/request"

const ContractService = {
    /**
     * 查询 客户凭证 列表
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6411
     */
    getInvoiceList(data) {
        return request({
            url:'/service/mg/invoice/list',
            method:'post',
            data
        });
    },
};

export default ContractService;

